import templateUrl from './rhnscny-logo.html';

export const rhnscnyLogoComponent = {
    bindings: {
        details: '<'
    },

    templateUrl,

    controller: class RhnscnyLogoComponent {
        constructor($state, ModalService, CompareObjectService, RhnscnyService, toastr) {
            'ngInject';

            this.$state = $state;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
            this.rhnscnyService = RhnscnyService;
            this.toastr = toastr;
        }

        $onInit() {
			this.rhnscnyLogoDetails = this.rhnscnyService.getRhnscnyLogo(this.details);
            this.pageTitle = "RHNSCNY Logo";
            this.disableButtons = false;
            this.savedData = angular.copy(this.rhnscnyLogoDetails);
        }

        onlogoUpload({details: {uuid}}) {
			this.rhnscnyLogoDetails.image = uuid;
		}

        onSubmit() {
            this.disableButtons = true;
			// submit the request
			this.rhnscnyService.updateWebsiteLogo(this.rhnscnyLogoDetails).then((details) => {
				this.toastr.success('Website logo updated successfully');
				this.disableButtons = false;
			}).catch((err) => {
        		this.toastr.error(err);
        		this.disableButtons = false;
      		});
        }

        onCancel() {
			const _details = angular.copy(this.rhnscnyLogoDetails);
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
			if(isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},
	
					buttons: [
						{
							name: 'No'
						},
						{
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}
					]
				});
			} else {
				this._redirectToParentState('home-banner');
			}			

			function onSubmit() {
				this._redirectToParentState('home-banner');
			}
		}

		_redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/components/rhnscny-logo/rhnscny-logo.component.js